module.exports = __webpack_public_path__ + "img/prayer-journal_B095G5JWLS.cae8172d.jpg";